import { BaseModel } from './base.model';

export class ReceptionConfigModel extends BaseModel {
  receptions: any[];
  twilio: { callerId: string } | undefined;
  defaultMeetingBufferHours: number;
  useLockCodeAsAuthCode: boolean;
  colors: any[];

  logoUrl: string;
  logoDarkUrl: string;
  logoOnlyUrl: string;
  logoOnlyDarkUrl: string;

  get initialValues() {
    return {
      logoUrl: '/assets/images/logo/service-central-logo.png',
      logoDarkUrl: '/assets/images/logo/service-central-logo.png',
      logoOnlyUrl: '/assets/images/logo/service-central-logo-only.png',
      logoOnlyDarkUrl: '/assets/images/logo/service-central-logo-only.png',
      useLockCodeAsAuthCode: false,
      defaultMeetingBufferHours: 2,
      receptions: [],
    }
  }

}
